<template>
  <div class="reference-item">
    <div
      class="d-flex justify-space-between align-center"
      :class="{ 'flex-wrap': isMobile }"
    >
      <div class="d-flex flex-column align-start">
        <Chip :status="reference.status" class="chip--status">
          {{ reference.status }}
        </Chip>
        <h3 class="mt-2">{{ reference.referenceTypeName }}</h3>
        <label class="subtext" v-if="duration">{{ duration }}</label>
      </div>
      <Permissioned section="references" :id="reference.id" class="flex-wrap">
        <SubmitForApprovalAction
          :referenceId="reference.id"
          permission="submit-for-approval"
          class="mr-2 my-1"
        />
        <EditReferenceAction
          class="mr-2 my-1"
          permission="edit"
          :reference="reference"
          :candidate="candidate"
          @updated="onUpdate"
        />
        <ApproveRejectReferenceAction
          class="mr-2 my-1"
          permission="reject"
          @submit="updateReference"
          :updating="updating"
        />
        <ApproveRejectReferenceAction
          class="my-1"
          permission="approve"
          @submit="updateReference"
          :updating="updating"
          isApprove
        />
      </Permissioned>
    </div>
    <v-divider class="my-2" />
    <div
      class="d-flex justify-space-between"
      :class="{ 'flex-column': isMobile, 'align-center': !isMobile }"
    >
      <div>
        <div class="d-flex align-end">
          <h3 class="mr-2">{{ refereeFullName }}</h3>
          <label class="subtext" v-if="referee.jobTitle || referee.company">
            {{ referee.jobTitle }}, {{ referee.company }}
          </label>
        </div>
        <div class="text-primary mt-1">
          <a :href="`tel:${referee.phoneNumber}`">{{ referee.phoneNumber }}</a>
          |
          {{ referee.emailAddress }}
        </div>
      </div>
      <Permissioned section="references" :id="reference.id">
        <PrimaryButton
          :class="{ 'mt-2': isMobile }"
          v-if="size(reference.conversations)"
          permission="view-conversation"
          class="reference-actions conversation"
          @click.native="viewConversation"
          text
          shrink
        >
          View Conversation
          <v-icon class="ml-2">mdi-message-processing-outline</v-icon>
        </PrimaryButton>
      </Permissioned>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import Chip from "@/components/common/Chip";
import Permissioned from "@/components/common/Permissioned";
import { getTextDate } from "@/utils/time";
import {
  APPROVE_REFERENCE,
  REJECT_REFERENCE
} from "@/store/modules/references/actions";
import { REFERENCES_NAMESPACE } from "@/store/modules/references";
import { createNamespacedHelpers } from "vuex";
import EditReferenceAction from "@/views/offers/components/compliances/actions/EditReferenceAction";
import { getFullName } from "@/utils/users";
import SubmitForApprovalAction from "@/views/offers/components/compliances/actions/SubmitForApprovalAction";
import ApproveRejectReferenceAction from "@/views/offers/components/compliances/actions/ApproveRejectReferenceAction";
import { size, first } from "lodash";

const { mapActions } = createNamespacedHelpers(REFERENCES_NAMESPACE);

export default {
  props: {
    reference: {
      type: Object,
      required: true
    },
    candidate: {
      type: Object,
      required: true
    }
  },
  components: {
    PrimaryButton,
    Chip,
    Permissioned,
    EditReferenceAction,
    SubmitForApprovalAction,
    ApproveRejectReferenceAction
  },
  data() {
    return {
      updating: false
    };
  },
  computed: {
    duration() {
      return this.reference.periodStartDate && this.reference.periodEndDate
        ? `${getTextDate(this.reference.periodStartDate)} - ${getTextDate(
            this.reference.periodEndDate
          )}`
        : "";
    },
    referee() {
      return this.reference.referee || {};
    },
    refereeFullName() {
      return this.reference.referee ? getFullName(this.reference.referee) : "";
    }
  },
  methods: {
    ...mapActions({
      approveReference: APPROVE_REFERENCE,
      rejectReference: REJECT_REFERENCE
    }),
    async updateReference(isApprove) {
      this.updating = true;
      isApprove
        ? await this.approveReference(this.reference.id)
        : await this.rejectReference(this.reference.id);
      this.updating = false;
      this.onUpdate();
    },
    onUpdate() {
      this.$emit("updated");
    },
    viewConversation() {
      const id = first(this.reference.conversations).id;
      this.$router.push({
        name: "conversationDetails",
        params: { conversationId: id }
      });
    },
    size
  }
};
</script>

<style lang="scss">
.reference-item {
  padding: 20px;
  margin: 20px 0;
  border: 1px solid $default-line-transparent;
  border-radius: 5px;
}
</style>
